var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg48(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    height: "48px",
    width: "48px",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.36,21.9l-4.48-3.6c-1.62-1.3-3.84-1.61-5.73-0.74c-0.91,0.42-1.74,0.99-2.46,1.68 c-0.03,0.03-0.02,0.07,0.01,0.09l6.51,4.52c0.04,0.03,0.06,0.09,0.02,0.14l-2.76,3.97c-0.03,0.04-0.09,0.06-0.14,0.02l-6.12-4.25 c-0.03-0.02-0.08-0.01-0.09,0.04c-0.15,0.64-0.23,1.31-0.23,2c0,3.63,2.14,6.76,5.22,8.19c1.9,0.89,4.14,0.59,5.77-0.72l4.48-3.6 c0.21-0.17,0.47-0.26,0.74-0.26h26.45c1.98,0,3.58-1.6,3.58-3.58v-0.07c0-1.98-1.6-3.58-3.58-3.58H17.1 C16.83,22.16,16.57,22.07,16.36,21.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg48);
export default __webpack_public_path__ + "static/media/48.c6115040aaf0ffa88ef217761aabba5e.svg";
export { ForwardRef as ReactComponent };